import { useLocation, Redirect } from 'quartz-routing/react-router';
import { EmbeddedContentPage } from '../components/EmbeddedContentPage';
import { Paths } from '../constants/Paths';
import { QUOTES_IFRAME_SANDBOX } from '../constants/IFrameSandbox';
import { jsx as _jsx } from "react/jsx-runtime";
export function QuoteDetailsPage() {
  var _location$state, _location$state2;
  const location = useLocation();
  const quoteUrl = (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.quoteUrl;
  const quoteName = (_location$state2 = location.state) === null || _location$state2 === void 0 ? void 0 : _location$state2.quoteName;
  if (!quoteUrl) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: Paths.QUOTES
    });
  }
  return /*#__PURE__*/_jsx(EmbeddedContentPage, {
    src: quoteUrl,
    title: "Quote",
    breadcrumbs: [{
      label: 'quoteDetails.breadcrumb.quotes',
      href: Paths.QUOTES
    }, {
      label: quoteName ? 'quoteDetails.breadcrumb.viewing' : 'quoteDetails.breadcrumb.quoteDetails',
      options: quoteName ? {
        quoteName
      } : undefined
    }],
    subscreen: "quote-details",
    sandbox: QUOTES_IFRAME_SANDBOX
  });
}